import script from "./BaseTag.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTag.vue?vue&type=script&setup=true&lang=js"

import "./BaseTag.vue?vue&type=style&index=0&id=04b01004&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04b01004"]])

export default __exports__